import React from 'react';
import { Switch, Route } from 'react-router-dom';

import EditUser from './EditUser';
import NewUser from './NewUser';
import ListUsers from './ListUsers';

function UsersPage() {
  return (
    <Switch>
      <Route exact path="/users" component={ListUsers} />
      <Route path="/users/new" component={NewUser} />
      <Route path="/users/:id" component={EditUser} />
    </Switch>
  );
}

export default UsersPage;
